<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {JobMode} from "@/modules/redactor/models/worker/jobs/JobMode";

export default {
  name: "r-job-mode",
  props: {
    model: VueTypes.instanceOf(JobMode),
    label: VueTypes.string.def("JobModel type:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return JobMode.getValues();
    }
  }
}

</script>